/**
 * TanStack Query hooks for news management
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  getNewsArticles,
  createNewsArticle,
  updateNewsArticle,
  deleteNewsArticle,
} from '../services/api'
import type { NewsArticleInput } from '../types'

export function useNewsArticles() {
  return useQuery({
    queryKey: ['news'],
    queryFn: getNewsArticles,
  })
}

export function useCreateNewsArticle() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createNewsArticle,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['news'] })
    },
  })
}

export function useUpdateNewsArticle() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<NewsArticleInput> }) =>
      updateNewsArticle(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['news'] })
    },
  })
}

export function useDeleteNewsArticle() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteNewsArticle,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['news'] })
    },
  })
}
